import { RouteFactory } from "@app/routePaths";
import { AdvertisementTypeEnum } from "@app/types/enums";
import internationalGlobalLogo from "@assets/verticals/international-global-logo-blue.svg";
import SCLogo from "@assets/verticals/standard-chartered-logo.svg";
import { AdTargetingType } from "@components/Advertisement/AdUnit";
import Advertisement from "@components/Advertisement/Advertisement";
import Banner from "@components/Banner/Banner";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";
import { GoogleAdsSlotFactory } from "@util/helpers";

export default function GlobalEnterpriseBanner({
  slotTargettings = [],
}: {
  slotTargettings?: AdTargetingType[];
}): React.ReactElement {
  return (
    <>
      <SectionMasthead
        link={RouteFactory.globalEnterprise}
        masthead={{
          alt: "Global Enterprise logo",
          src: internationalGlobalLogo,
          width: 146,
          height: 47,
        }}
      />

      <Banner rootClassName="w-full bg-gray-250 py-3">
        <div className="flex flex-row items-center justify-center gap-x-4 lg:justify-end">
          <span className="font-poppins text-base font-light uppercase">
            BROUGHT TO YOU BY
          </span>
          <img
            src={SCLogo}
            alt="Standard Charted Logo"
            width="95"
            height="50"
          />
        </div>
      </Banner>

      <Advertisement
        rootClassName="pb-6"
        adUnitProps={{
          slot: GoogleAdsSlotFactory.lb1(
            RouteFactory.globalEnterprise.replace("/", "")
          ),
          type: AdvertisementTypeEnum.LB1,
          slotTargettings: slotTargettings,
        }}
      />

      <Advertisement
        adUnitProps={{
          type: AdvertisementTypeEnum.CATFISH,
          slot: GoogleAdsSlotFactory.catfish(
            RouteFactory.globalEnterprise.replace("/", "")
          ),
          slotTargettings: slotTargettings,
        }}
      />
    </>
  );
}
